import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import { EditContactOpenMdalReducer } from "../redux/adityaReducer";
import AddContacts from "../user/componants/contact/AddContacts";
import CloseIcon from "@mui/icons-material/Close";
import UpdateIcon from "@mui/icons-material/Update";
import AddIcon from "@mui/icons-material/Add";
import {
  ad_Json_CRMSaveUDFValues_Action,
  ad_Json_GetCRMContactUDFValues_Action,
  ad_Json_UpdateContact_Action,
} from "../redux/dev_aditya_action";
import { getAllContactsByClientID } from "../redux/dev_chetan_api_helper";
import { toast } from "react-toastify";
import moment from "moment";

const EditContactModal = ({ open, close, refreshData }) => {
  const [params, setsearchParams] = useSearchParams();
  const [contactData, setContactData] = useState();
  const [searchParams] = useSearchParams();
  const navigation = useNavigate();
  const location = useLocation();

  const folderId = searchParams.get("folderId");
  const contactNo = searchParams.get("contactNo");
  const orgNo = searchParams.get("orgNo");

  const [userContactDetails, setContactDetails] = useState({
    Title: "",
    FirstName: "",
    LastName: "",
    ReferenceName: "",
    MainContact: false,
    Inactive: false,
    GreetingName: "",
    EmailName: contactData?.[0]["E-Mail"] ? contactData?.[0]["E-Mail"] : "",
    MainUserId: -1,
    MainUserName: "",
    MainLine1Name: "",
    MainLine2Name: "",
    MainLine3Name: "",
    MainTownName: "",
    MainPostcodeName: "",
    Maincontactcountry: "",
    MainTelephoneName: "",
    MainMobileName: "",
    mainCountry: "",
    billingsCountry: "",
    ragistersCountry: "",
    ReferenceID: "",
    BirthDate: "",
    RolesData: "",
    Base64ImgData: "",
    CreatePortal: false,
    Notes: "",
  });
  const [udfFieldChange, setUdfFieldChange] = useState([]);
  const [contactUdfFields, setContactUdfFields] = useState([]);

  const { allContactsByClientID_Redux } = useSelector(
    ({ dev_chetan }) => dev_chetan
  );
  const { getClientIdMethod, getFolderObject } = useSelector(({ ak }) => ak);

  const dispatch = useDispatch();

  const handleClose = () => {
    dispatch(EditContactOpenMdalReducer(false));
    close && close();
  };

  useEffect(() => {
    setContactData();
    allContactsByClientID_Redux.length > 0 &&
      contactNo &&
      setContactData(
        allContactsByClientID_Redux.filter(
          (itm) => Number(itm.ContactNo) === Number(contactNo)
        )
      );
  }, [allContactsByClientID_Redux, contactNo]);

  const handleSubmit = async (event) => {
    event.preventDefault();
    // console.log(contactData, "contactData");
    if (contactData && contactData.length > 0) {
      let contactDataObg = {
        FirstName: userContactDetails.FirstName
          ? userContactDetails.FirstName
          : "",
        LastName: userContactDetails.LastName
          ? userContactDetails.LastName
          : "",
        Add1: userContactDetails.MainLine1Name
          ? userContactDetails.MainLine1Name
          : "",
        Add2: userContactDetails.MainLine2Name
          ? userContactDetails.MainLine2Name
          : "",
        Add3: userContactDetails.MainLine3Name
          ? userContactDetails.MainLine3Name
          : "",
        Town: userContactDetails.MainTownName
          ? userContactDetails.MainTownName
          : "",
        PostCode: userContactDetails.MainPostcodeName
          ? userContactDetails.MainPostcodeName
          : "",
        Country: userContactDetails.mainCountry
          ? userContactDetails.mainCountry
          : "United Kingdom",
        ManagerName:
          userContactDetails.FirstName + " " + userContactDetails.LastName,
        Role: userContactDetails.RolesData ? userContactDetails.RolesData : "",
        Tel: userContactDetails.MainTelephoneName
          ? userContactDetails.MainTelephoneName
          : "",
        Mobile: userContactDetails.MainMobileName
          ? userContactDetails.MainMobileName
          : "",
        greeting: userContactDetails.GreetingName
          ? userContactDetails.GreetingName
          : "",
        Contactemail: userContactDetails.EmailName
          ? userContactDetails.EmailName
          : "",
        note: userContactDetails.Notes ? userContactDetails.Notes : "",
        emailupdate: contactData[0]["E-Mail"] ? contactData[0]["E-Mail"] : "",
        CActive: userContactDetails.Inactive === false ? "Yes" : "No",
        AssignedManager: userContactDetails.MainUserId
          ? userContactDetails.MainUserId
          : -1,
        maincontact: userContactDetails.MainContact
          ? userContactDetails.MainContact
          : false,
        CCode: contactData[0].OriginatorNo ? contactData[0].OriginatorNo : "-1",
        Salutation: userContactDetails.Title ? userContactDetails.Title : "",
        accid: localStorage.getItem("accid"),
      };

      dispatch(
        ad_Json_UpdateContact_Action(contactDataObg, (res) => {
          // dispatch(setAllContactsByClientID([]));
          dispatch(
            getAllContactsByClientID(
              contactData[0]?.OriginatorNo,
              folderId ? folderId : getFolderObject
            )
          );
          if (location.pathname === "/user/portal-messages") {
            navigation("/user/portal-messages");
          }

          toast.success("Contact updated");
          handleClose();
        })
      );

      let contactBody = {
        ClientId: contactData[0]?.OriginatorNo
          ? contactData[0]?.OriginatorNo
          : "-1",
        ContactNo: contactData[0]?.ContactNo,
        fieldName: "BirthDate",
        fieldValue: moment(userContactDetails.BirthDate).format("DD/MM/YYYY"),
        projectid: "171",
      };
      // const res = await dispatch(ad_UpdateContactField_Json_Action(contactBody));
      // console.log("Response data:", res);
    }

    HandleUpdateUdf();
    refreshData && refreshData();
  };

  const HandleUpdateUdf = async () => {
    if (udfFieldChange.length > 0) {
      udfFieldChange.forEach((udf) => {
        let ProjectId = udf.folderId;

        if (udf.field.length > 0) {
          let ClientUDFString = udf.field
            .map((udfField) => {
              // Only include fields that have a valid UdfValue
              if (udfField?.UdfValue) {
                return `${udfField?.UserDefFieldID}_${
                  udfField?.UserDefFieldTypeID
                }_${
                  udfField?.TextControlValue
                }_UDF:${udfField?.UdfValue.trim()}`;
              }
              return null; // Return null for fields that don't meet the condition
            })
            .filter(Boolean) // Remove null or undefined values
            .join(","); // Join the array into a single string separated by commas
          let udfBody = {
            OriginatorNo: getClientIdMethod,
            ProjectId,
            ClientUDFString: "",
            ContactUDFString: ClientUDFString,
            ContactNo: contactNo,
          };

          dispatch(
            ad_Json_CRMSaveUDFValues_Action(udfBody, (res) => {
              let UdfBody = {
                ClientId: getClientIdMethod,
                ContactId: contactNo,
                ProjectId: folderId ? folderId : getFolderObject,
              };
              dispatch(
                ad_Json_GetCRMContactUDFValues_Action(UdfBody, (res) => {
                  setContactUdfFields(res);
                })
              );
              setUdfFieldChange([]);
            })
          );
        }
      });
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="custom-modal full-modal"
      fullWidth
      maxWidth="lg"
    >
      <Box className="d-flex align-items-center justify-content-between modal-head p-3">
        <Box className="dropdown-box">
          <Typography variant="h4" className="font-18 bold text-black mb-0">
            Edit Contact
          </Typography>
        </Box>

        {/*  */}
        <Button startIcon={<CloseIcon />} onClick={handleClose}></Button>
      </Box>

      {/* <hr /> */}

      <DialogContent className="" id="alert-dialog-description">
        <AddContacts
          handleClose51={handleClose}
          contactDetails={contactData}
          refreshData={refreshData}
          // handle form data
          userContactDetails={userContactDetails}
          setContactDetails={setContactDetails}
          // render udf fields
          contactUdfFields={contactUdfFields}
          setContactUdfFields={setContactUdfFields}
          // handle udf
          setUdfFieldChange={setUdfFieldChange}
          udfFieldChange={udfFieldChange}
        />
      </DialogContent>
      <DialogActions>
        {contactData && contactData.length > 0 ? (
          <Button
            variant="contained"
            onClick={handleSubmit}
            className="btn-blue"
            startIcon={<UpdateIcon />}
          >
            Update Contact
          </Button>
        ) : (
          <Button
            style={{ marginTop: "5px" }}
            variant="contained"
            // disabled={!defaultclientData}
            onClick={handleSubmit}
            className="btn-blue"
            startIcon={<AddIcon />}
          >
            Add New Contact
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default EditContactModal;
